import i18next from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
i18next.use(initReactI18next).init({
  lng: "english", // Default language
  fallbackLng: "english",
  resources: {
    english: {
      translation: {
        "Welcome to React": "Welcome to React and react-i18next",
      },
    },
  },
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

export default i18next;
